/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_ExpiredInputs */

const fr_error_invitation_expired = /** @type {(inputs: Error_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce lien a expiré. Demandez-en un nouveau à un administrateur.`)
};

const en_error_invitation_expired = /** @type {(inputs: Error_Invitation_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link has expired. Ask an administrator for a new one.`)
};

/**
* | output |
* | --- |
* | "This link has expired. Ask an administrator for a new one." |
*
* @param {Error_Invitation_ExpiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_invitation_expired = /** @type {((inputs?: Error_Invitation_ExpiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_ExpiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_invitation_expired(inputs)
	return fr_error_invitation_expired(inputs)
});